import { __read } from "tslib";
import { useMemo, useRef, useState } from 'react';
export function useHover(props) {
    var _a = __read(useState(false), 2), isHovered = _a[0], setHovered = _a[1];
    var propsRef = useRef({});
    // Use ref as cache for reuse props inside memo hook.
    propsRef.current = { disabled: props.disabled };
    var hoverProps = useMemo(function () {
        var props = {};
        props.onPointerEnter = function () {
            var disabled = propsRef.current.disabled;
            if (disabled) {
                return;
            }
            setHovered(true);
        };
        props.onPointerLeave = function () {
            setHovered(false);
        };
        return props;
    }, []);
    return {
        isHovered: isHovered,
        hoverProps: hoverProps,
    };
}
